import React, { useState, useEffect } from 'react';
import './Animation.css';
import { ColumnOrdering } from '@tanstack/react-table';

export default function HandwritingAnimation({ onComplete }) {
  const [isAnimating, setIsAnimating] = useState(true);
  const salutation  ="Bienvenue chez ";
  const companyName = {
    name: "TOGO     3000",
    color: "#e90808ff"
  }
  const word={
    name: "INFORMATIQUE",
    color: "#4c09c9ff"
  }
  const text = `${salutation}${companyName.name}${word.name}`;


  
  // Calculer la durée totale de l'animation
  const animationDuration = (text.length * 0.1) + 2;
  
  useEffect(() => {
    const timer = setTimeout(() => {
      if (onComplete) {
        onComplete();
      }
    }, animationDuration * 1500);
    
    return () => clearTimeout(timer);
  }, [onComplete, animationDuration]);

  return (
    <div className="animation-container">
      <div className="animation-wrapper">
        <div className="animation-card">
          {/* Lignes de cahier */}
          <div className="notebook-lines">
            {[...Array(10)].map((_, i) => (
              <div
                key={i}
                className="notebook-line"
                style={{ top: `${(i + 1) * 10}%` }}
              />
            ))}
          </div>

          {/* Texte manuscrit */}
{/* Texte manuscrit */}
          <div className="text-content">
            <h1 className="animation-title">
              {salutation.split('').map((char, index) => (
                <span
                  key={`sal-${index}`}
                  className="letter"
                  style={{
                    animationDelay: `${index * 0.1}s`,
                    color: '#1f2937'
                  }}
                >
                  {char === ' ' ? '\u00A0' : char}
                </span>
              ))}
              {companyName.name.split('').map((char, index) => (
                <span
                  key={`comp-${index}`}
                  className="letter"
                  style={{
                    animationDelay: `${(salutation.length + index) * 0.1}s`,
                    color: companyName.color
                  }}
                >
                  {char === ' ' ? '\u00A0' : char}
                </span>
              ))}
              {' '.split('').map((char, index) => (
                <span
                  key={`dash-${index}`}
                  className="letter"
                  style={{
                    animationDelay: `${(salutation.length + companyName.name.length + index) * 0.1}s`,
                    color: '#1f2937'
                  }}
                >
                  {char === ' ' ? '\u00A0' : char}
                </span>
              ))}
              {word.name.split('').map((char, index) => (
                <span
                  key={`word-${index}`}
                  className="letter"
                  style={{
                    animationDelay: `${(salutation.length + companyName.name.length + 3 + index) * 0.1}s`,
                    color: word.color
                  }}
                >
                  {char === ' ' ? '\u00A0' : char}
                </span>
              ))}
              <p>Un millénaire d’avance…</p>
            </h1>
            </div>

          {/* Indicateur de chargement */}
          <div 
            className="loading-indicator"
                style={{
                    animationDelay: `${text.length * 0.1 + 1.5}s`,
                    background: companyName.name === text ? companyName.color : word.color, // Use 'background' instead
                    backgroundClip: 'text', // Standard property
                    WebkitBackgroundClip: 'text', // Webkit prefix for Safari
                    color: 'transparent', // Standard property
                    WebkitTextFillColor: 'transparent', // Webkit prefix
                }}
          >
            <div className="loading-dots">
              <div className="loading-dot" style={{ animationDelay: '0s' }}></div>
              <div className="loading-dot" style={{ animationDelay: '0.1s' }}></div>
              <div className="loading-dot" style={{ animationDelay: '0.2s' }}></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}